import _extends from "@babel/runtime/helpers/extends";
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { Switch } from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import * as React from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { MuiStack } from '../../components';
import { setAccordianClosed, setIsTaskDetailsDataUpdated, setTaskDetailsDataSaved } from '../../redux/commonSlice';
import { bajajPrimaryBlue } from '../../theme/palette';
import useAnalyticsEventTracker from '../../utils/useAnalyticsEventTracker';
var Accordion = styled(function (props) { /*#__PURE__*/ return React.createElement(MuiAccordion, _extends({
    disableGutters: true,
    elevation: 0,
    square: true
}, props)); })(function (_ref) {
    var theme = _ref.theme;
    return {
        borderRadius: '12px'
    };
});
var AccordionSummary = styled(function (props) { /*#__PURE__*/ return React.createElement(MuiAccordionSummary, _extends({
    expandIcon: /*#__PURE__*/ React.createElement(ArrowForwardIosSharpIcon, {
        sx: {
            fontSize: '0.9rem'
        }
    })
}, props)); })(function (_ref2) {
    var theme = _ref2.theme;
    return {
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)'
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1)
        }
    };
});
var AccordionDetails = styled(MuiAccordionDetails)(function (_ref3) {
    var theme = _ref3.theme;
    return {
        padding: theme.spacing(2),
        borderTop: '1px solid rgba(0, 0, 0, .125)'
    };
});
var IOSSwitch = styled(function (props) { /*#__PURE__*/ return React.createElement(Switch, _extends({
    focusVisibleClassName: ".Mui-focusVisible",
    disableRipple: true
}, props)); })(function (_ref4) {
    var theme = _ref4.theme;
    return {
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? bajajPrimaryBlue : bajajPrimaryBlue,
                    opacity: 1,
                    border: 0
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5
                }
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff'
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: theme.palette.mode === 'light' ? 0.7 : 0.3
            }
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500
            })
        }
    };
});
export default function CustomeAccordian(props) {
    var trackButtonClick = useAnalyticsEventTracker("CustomeAccordian");
    var _a = React.useState('All'), selectedItem = _a[0], setSelectedItem = _a[1];
    var _b = React.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var _c = React.useState(false), accordionOpen = _c[0], setAccordionOpen = _c[1];
    var _d = React.useState(props.selected), switchEnabled = _d[0], setSwitchEnabled = _d[1];
    // console.log("switchButtonsEnabled", props.switchButtonsEnabled)
    var dispatch = useDispatch();
    var handleClickFun = function (event) {
        setAnchorEl(event.currentTarget);
    };
    useEffect(function () {
        if (!props.switchButtonsEnabled || !switchEnabled) {
            props === null || props === void 0 || props.handleAccordianClick(false);
        }
        // if (props.switchButtonsEnabled || switchEnabled) {
        //     props.getToggleValue(true)
        // }
        // if (switchEnabled) {
        //     props.handleClick();
        // }
    }, [props.switchButtonsEnabled, switchEnabled]);
    var onAccordianClick = function (event) {
        trackButtonClick("ButtonClickEvent", "SendOtpClick", undefined);
        props === null || props === void 0 || props.handleAccordianClick(!(props !== null && props !== void 0 && props.isAccordianOpen));
        dispatch(setAccordianClosed(!(props !== null && props !== void 0 && props.isAccordianOpen)));
        if (props.handleClick && !(props !== null && props !== void 0 && props.isAccordianOpen)) {
            props.handleClick();
        }
    };
    var onSwitchChange = function () {
        if (props.switchButtonsEnabled) {
            return;
        }
        else {
            // props.getToggleValue(!switchEnabled)
            setSwitchEnabled(!switchEnabled);
            if (switchEnabled) {
                dispatch(setTaskDetailsDataSaved(true));
            }
        }
        dispatch(setIsTaskDetailsDataUpdated(true));
    };
    return /*#__PURE__*/ React.createElement(Accordion, {
        sx: {
            border: "1px solid ".concat(props.switchButtonsEnabled || switchEnabled ? '#3697FF' : '#e0e0e0')
        },
        expanded: props === null || props === void 0 ? void 0 : props.isAccordianOpen
    }, /*#__PURE__*/ React.createElement(AccordionSummary, {
        sx: {
            flexDirection: 'row-reverse'
        },
        expandIcon: props.switchButtonsEnabled || switchEnabled ? /*#__PURE__*/ React.createElement(ArrowForwardIosSharpIcon, {
            sx: {
                fontSize: '0.9rem'
            },
            onClick: onAccordianClick,
            id: props === null || props === void 0 ? void 0 : props.KeyForId
        }) : null
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: "100%",
        alignItems: "center",
        sx: {
            marginLeft: '8px'
        },
        justifyContent: 'flex-start'
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: props.id,
        variant: "caption",
        sx: {
            color: "".concat(props.switchButtonsEnabled || switchEnabled ? '' : '#C3CCD6')
        }
    }, props.title), props.countVisible && /*#__PURE__*/ React.createElement(React.Fragment, null, props !== null && props !== void 0 && props.listLength ? /*#__PURE__*/ React.createElement(Typography, {
        id: "jobCount",
        style: {
            borderRadius: '20px',
            border: '1px solid #AFD5FF',
            width: '25px',
            height: '25px',
            marginLeft: '10px',
            backgroundColor: '#EEF6FF'
        },
        align: "center",
        color: "#AFD5FF"
    }, props === null || props === void 0 ? void 0 : props.listLength) : /*#__PURE__*/ React.createElement(Typography, {
        bgcolor: 'red',
        id: "".concat(props.title, "-count"),
        style: {
            borderRadius: '20px',
            border: '1px solid #AFD5FF',
            width: '25px',
            height: '25px',
            marginLeft: '10px',
            backgroundColor: '#EEF6FF'
        },
        align: "center",
        color: "#AFD5FF"
    }, 0)))), /*#__PURE__*/ React.createElement(AccordionDetails, null, props.children));
}
